import { Button, Modal, Spinner } from "react-bootstrap";

const Dialog = ({ title, show, onClose, children, description, onSubmit, submitButtonText = "Confirm", abortButtonText = "Cancel", disableBackdrop = false, isLoading = false }) => {

    return (
        <Modal backdrop={!disableBackdrop} show={show} onHide={onClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {description}
                {children}
            </Modal.Body>
            <div className='d-flex gap-3 p-3 justify-content-end'>
                <Button style={{ width: "120px" }} variant="primary" onClick={onSubmit}>
                    {isLoading ? <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                    /> : submitButtonText}
                </Button>
                <Button style={{ width: "120px" }} variant="secondary" onClick={onClose}>
                    {abortButtonText}
                </Button>
            </div>
        </Modal>
    )
}

export default Dialog;